import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { IHubChecklistUser } from "interfaces/Hub";
import { Button } from "components/ui/ButtonGs";
import { useMutation, useQueryClient } from "react-query";
import { useHubChecklistUser } from "hooks/api";
import { useErrorHandler } from "exceptions/ErrorHandler";
import { toast } from "sonner";
interface IDeleteProps {
  isOpen: boolean;
  data: IHubChecklistUser;
  onClose: () => void;
}
export const HubDeleteChecklistUser: React.FC<IDeleteProps> = ({
  isOpen,
  data,
  onClose,
}) => {
  const { deleteChecklistUser } = useHubChecklistUser();
  const { errorHandler } = useErrorHandler();
  const queryClient = useQueryClient();
  const mutation = useMutation(() => deleteChecklistUser(data.id), {
    onSuccess: () => {
      queryClient.invalidateQueries("deleteChecklistUser");
      toast.success("Usuário removido com sucesso");
      onClose();
    },
    onError: (error) => {
      errorHandler(error);
    },
  });

  const handleConfirm = () => {
    mutation.mutate();
  };
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-GilroyBold text-lg tracking-normal">
            Você tem certeza dessa exclusão?
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <article className="mb-4">
            Está é uma ação irreversível, caso você tenha certeza que deseja
            excluir o Usuário, clique no botão{" "}
            <span className="font-bold">Deletar</span>. Caso contrário, clique
            no botão <span className="font-bold">cancelar</span>.
          </article>
          <div className="bg-slate-100 p-4 border-slate-300 rounded-sm text-sm font-medium shadow-inner">
            Excluir: <span className="text-red-500">{data.name}</span>
          </div>
        </DialogDescription>
        <DialogFooter>
          <Button.Root size="sm" variant="secondary" onClick={onClose}>
            Cancelar
          </Button.Root>
          <Button.Root
            size="sm"
            variant="danger"
            onClick={() => handleConfirm()}
            disabled={mutation.isLoading}
          >
            Deletar
          </Button.Root>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
